import React from "react";
import FunctionDefinedComponents, {RolledChildType} from "../handler-components/FunctionDefinedComponents";
import {OrderContextValues} from "../../contexts/OrderContext";
import * as Navigator from "../../refrences/RootNavigation";

interface state {
}

interface props {
    orderContext: OrderContextValues,
    children: any
}

export default class OrderProgressComponents extends FunctionDefinedComponents <props, state> {

    constructor(props: any) {
        super(props);
    }

    back() {
        Navigator.replace("Menu");
    }

    rolledChildren(): RolledChildType {
        return [
            {
                role: "status-text",
                visible: true,
                props: {},
                children: `وضعیت سفارش: ${this.props.orderContext.order?.getLastStageInfo()?.textStatus ?? "نا مشخص"}`
            },
            {
                role: "time-text",
                visible: true,
                props: {},
                children: `مدت زمان تقریبی آماده سازی: ${this.props.orderContext.order?.preparationTime ?? 0} دقیقه`

            },
            {
                role: "back-button",
                visible: (this.props.orderContext.order?.orderIsDone() ?? false),
                props: {
                    title: "بازگشت به صفحه اصلی",
                    onPress: () => {
                        this.back();
                    }
                },
                children: null
            },
        ];
    }

}
